export default {
  methods: {
    blur(){
      this.$refs.input.blur() 
      let unfocusable = ()=> this.$refs.input.blur() 
      this.$refs.input.addEventListener('focus', unfocusable, false);
      setTimeout(()=>this.$refs.input.removeEventListener('focus', unfocusable, false), 200)
    }
  }
}